/** Read a fetch Response body once and parse JSON safely. */
export async function parseResponseJson(response) {
  const text = await response.text();
  if (!text) {
    return { data: {}, text: '' };
  }
  try {
    return { data: JSON.parse(text), text };
  } catch {
    return { data: { _raw: text }, text };
  }
}

export function formatApiDetail(data, fallback = 'Request failed') {
  const detail = data?.detail ?? data?.message ?? data?.error;
  if (Array.isArray(detail)) {
    return detail.map((item) => item?.msg || String(item)).join('; ') || fallback;
  }
  if (detail && typeof detail === 'object') {
    if (typeof detail.message === 'string' && detail.message.trim()) return detail.message;
    if (typeof detail.error === 'string' && detail.error.trim()) return detail.error;
  }
  if (typeof detail === 'string' && detail.trim()) return detail;
  if (typeof data?._raw === 'string' && data._raw.trim()) {
    return data._raw.slice(0, 240);
  }
  return fallback;
}

function hasApiPath(value) {
  try {
    const url = new URL(value);
    return url.pathname.replace(/\/$/, '').endsWith('/api');
  } catch {
    return value.replace(/\/$/, '').endsWith('/api');
  }
}

/** Same-origin `/api` in dev (setupProxy); absolute `/api` URL when REACT_APP_BACKEND_URL is set. */
export function resolveApiBase() {
  const env = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '');
  if (env) return hasApiPath(env) ? env : `${env}/api`;
  if (typeof window !== 'undefined' && window.location?.origin) {
    return `${window.location.origin}/api`;
  }
  return 'http://127.0.0.1:8002/api';
}

export function apiPath(path) {
  const rawPath = String(path || '').replace(/^\/+/, '');
  const apiRelativePath = rawPath.replace(/^api(?:\/|$)/, '');
  const base = resolveApiBase().replace(/\/$/, '');
  return apiRelativePath ? `${base}/${apiRelativePath}` : base;
}
